import { Phone, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import Logo from "./Logo";

const NAV = [
  { label: "Gallery", href: "#portfolio" },
  { label: "Savings", href: "#savings" },
  { label: "Merch", href: "#merch" },
  { label: "Story", href: "#story" },
  { label: "Service Area", href: "#service-area" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/80 border-b border-neutral-900"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid grid-cols-[1fr_auto_1fr] items-center gap-4 h-20 md:h-24">
        {/* Left: nav */}
        <nav className="hidden lg:flex items-center gap-6 justify-start whitespace-nowrap">
          {NAV.slice(0, 2).map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.replace("#", "")}`}
              className="text-sm font-medium text-neutral-400 hover:text-[#F5F5F0] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* Center: logo */}
        <a
          href="#top"
          data-testid="brand-link"
          className="justify-self-start lg:justify-self-center flex items-center"
        >
          <Logo className="h-16 md:h-20 w-auto" />
        </a>

        {/* Right: rest of nav + CTAs */}
        <div className="flex items-center gap-5 justify-end whitespace-nowrap">
          <nav className="hidden lg:flex items-center gap-6">
            {NAV.slice(2).map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-${n.href.replace("#", "")}`}
                className="text-sm font-medium text-neutral-400 hover:text-[#F5F5F0] transition-colors"
              >
                {n.label}
              </a>
            ))}
          </nav>
          <a
            href="tel:4033935772"
            data-testid="nav-phone-link"
            className="hidden md:inline-flex items-center gap-2 text-sm font-medium text-[#F5F5F0] hover:text-neutral-300"
          >
            <Phone size={14} />
            403-393-5772
          </a>
          <a
            href="#quote-form"
            data-testid="nav-quote-cta"
            className="hidden sm:inline-flex bg-[#F5F5F0] text-black px-4 py-2 text-sm font-semibold hover:bg-[#EAEAE5] transition-colors"
          >
            Get a Quote
          </a>
          <button
            data-testid="mobile-menu-btn"
            className="lg:hidden text-[#F5F5F0]"
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-neutral-900 bg-black"
        >
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.href.replace("#", "")}`}
                className="text-neutral-300 py-1.5"
              >
                {n.label}
              </a>
            ))}
            <a
              href="tel:4033935772"
              className="text-[#F5F5F0] font-semibold pt-2"
              data-testid="mobile-nav-phone"
            >
              Call 403-393-5772
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
